<template>
  <div class="">
    <div class="">
            <span>انتخاب کاربر

            <span class="text-primary" v-if="selectedUser">({{ selectedUser.name }} {{ selectedUser.last_name }})</span>

            </span>

    </div>
    <form @submit.prevent="loadUsers">
      <div class="row justify-content-center">
        <b-form-input
            v-model="userSearchWord"
            class="col-8"
            placeholder="نام، نام خانوادگی، شماره تلفن"
        ></b-form-input>

        <b-button
            class="col-3 mr-1"
            @click="loadUsers"
            variant="primary">
          جستجو
        </b-button>
      </div>

      <div class="choose-item-section-users my-1" v-if="users.length > 0">
        <div v-for="user in users" class="cursor-pointer choose-item py-2 "
             @click="selectedUserItem(user)">
          {{ user.name }} {{ user.last_name }}
        </div>
      </div>

    </form>
  </div>
</template>

<script>
export default {
  name: "UserFilter2",
  props: {
    user: {
      default: null,
    },
    roles: {
      default: null,
    }
  },
  data() {
    return {
      userSearchWord: '',
      users: [],
      selectedUser: null,
    }
  },
  methods: {
    loadUsers() {
      if (this.roles != null) {
        this.$store.commit("User/setFilters", {key: "role", value: this.roles});
      }
      this.$store.commit('User/setFilters', {key: 'search', value: this.userSearchWord})
      let req = this.$store.dispatch('User/getPersonsWithoutState')
      req.then(res => {
        this.users = res.data.data.data
      })
    },
    selectedUserItem(item) {
      this.selectedUser = item
      this.users = []
      this.$emit("change_user", item)
    },
  },
  watch: {
    user: {
      async handler(newValue, oldValue) {
        if (newValue != null) {
          this.selectedUser = this.user
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.choose-item-section-users {
  overflow: auto;
  background: #f5f5f5;
  z-index: 1;
  padding: 5px;
  height: 110px;
  position: absolute;
  width: 93%;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}
</style>